import React from "react";
import { Menu } from "primereact/menu";
import { LoaderOverlay } from "../../../ui";
import { useSafeNavigation } from "@hooks";
import { getAdminSidebarMenus } from "./constants";
import { STRING } from "@constants";
import { ManualPanelMenu } from "./ManualPanelMenu";

export function Sidebar() {
  const { safeNavigate, navigating, location } = useSafeNavigation();

  const { menuItems, panelMenuItems, menuItemsSecond, panelMenuItemsSecond } =
    React.useMemo(
      () => getAdminSidebarMenus(safeNavigate, location.pathname),
      [safeNavigate, location.pathname],
    );

  return (
    <div className="sidebar-container relative">
      <LoaderOverlay visible={navigating} />

      <div className="sidebar-header p-3">
        <div className="flex align-items-center">
          <div
            className="w-3rem h-3rem border-circle flex align-items-center justify-content-center mr-3"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            <i className="pi pi-shop text-2xl text-white"></i>
          </div>
          <div>
            <h1
              className="text-xl font-bold text-900 m-0"
              style={{ letterSpacing: "-0.5px" }}
            >
              {STRING.LOGIN.TITLE}
            </h1>
            <p className="text-600 m-0 mt-1 font-medium">
              {STRING.ADMIN.SUBTITLE}
            </p>
          </div>
        </div>
      </div>

      <div>
        <Menu model={menuItems} className="sidebar-menu w-full border-none" />
      </div>
      <div>
        <ManualPanelMenu
          model={panelMenuItems}
          activePath={location.pathname}
          navigate={safeNavigate}
        />
      </div>
      <div>
        <Menu
          model={menuItemsSecond}
          className="sidebar-menu w-full border-none"
        />
      </div>
      <div>
        <ManualPanelMenu
          model={panelMenuItemsSecond}
          activePath={location.pathname}
          navigate={safeNavigate}
        />
      </div>
    </div>
  );
}
